import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import { isLoggedIn } from '../../../reducers/auth';
import { useLocation, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import ItemService from '../../../services/item.service';
import CatalogService from '../../../services/catalog.service';
import Spinner from "react-bootstrap/Spinner";

const ProductDetails = () => {
  let navigate = useNavigate();

  //  const catalogItem = useSelector(selectCatalogItem);
  const [catalogItem, setCatalogItem] = useState(null);
  //  const otherProductItems = useSelector(selectOtherCatalogItems);
  const [imgSrc, setImgSrc] = useState(null);
  const [imgSrcBack, setImgSrcBack] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(null);
  const [decorations, setDecorations] = useState([]);
  const [selectedDecoration, setSelectedDecoration] = useState([]);
  const [currentDragColor, setCurrentDragColor] = useState(null);
  const [currentColor, setCurrentColor] = useState(null);
  const [currentSize, setCurrentSize] = useState(null);
  const [currentDragColorSizes, setCurrentDragColorSizes] = useState([]);
  const location = useLocation();
  const loginStatus = useSelector(isLoggedIn);
  const [show, setShow] = useState(false);
  const [addSizes, setAddSizes] = useState("");
  const [imageModalShow, setImageModalShow] = useState(false);
  const [content, setContent] = useState(null);
  const handleSizeModalClose = () => setShow(false);
  const [availableColors, setAvailableColors] = useState(null);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedLogos, setSelectedLogos] = useState([]);
  const [showSpinner, setShowSpinner] = useState(false);


  const selectedLogo = (e) => {
    console.log("Selected Logo", e.target.value);
    setSelectedDecoration(e.target.value);
  }

  const colorImageClick = (item) => {
    setImgSrc(item.frontModelImage);
    setImgSrcBack(item.backModelImage);
    setCurrentItem(item);
    setCurrentColor(item.colorName);
    setCurrentSize(0);
    setCurrentPrice(item.sizes[0].price.toLocaleString(undefined, { maximumFractionDigits: 2 }));
    console.log("CLICKED IMAGE");
  }

  const closeImageModal = () => {
    setImageModalShow(false);
  }

  const colorImageOver = (item) => {
    setImgSrc(item.frontModelImage);
    setImgSrcBack(item.backModelImage);
    setCurrentColor(item.colorName);
  }

  const colorImageExit = (item) => {
    setImgSrc(currentItem.frontModelImage);
    setCurrentColor(currentItem.colorName);
  }

  const sizeClick = (event) => {
    setCurrentSize(event.target.getAttribute("data"));
    setCurrentPrice(currentItem.sizes[event.target.getAttribute("data")].price.toLocaleString(undefined, { maximumFractionDigits: 2 }));

  }

  useEffect(() => {
    console.log("LOADING PRODUCT");
    let productId = location.state.productId;
    async function fetchMyAPI() {
      let item = await ItemService.getItemNonCatalog(productId);
      setCatalogItem(item.item);
      setDecorations(item.decorations);
      if (item.decorations && item.decorations[0])
        setSelectedDecoration(item.decorations[0].id);
      setCurrentItem(item.item[0]);
      setupProduct(item.item);
    }

    fetchMyAPI();
  }, []);


  const drop = (item) => {
    console.log("Item Dropped", item);
    setSelectedColors([...selectedColors, item]);
    var i = 0;
    for (i; i < availableColors.length; i++) {
      console.log("IDs", availableColors[i].id, item.id);
      if (availableColors[i].colorName === item.colorName) {
        break;
      }
    }
    availableColors.splice(i, 1);
    setAvailableColors(availableColors);
    console.log("Catalog Item after drop", catalogItem);
  };

  const addAll = () => {
    setSelectedColors([...selectedColors, ...availableColors]);
    setAvailableColors([]);
  };

  const removeAll = () => {
    setAvailableColors([...selectedColors, ...availableColors]);
    setSelectedColors([]);
  };

  const handleSizeCheck = (event) => {
    const target = event.target
    const checked = target.checked
    const label = target.id;
    var sizes = currentDragColorSizes;
    if (checked) sizes.push(label);
    else {
      for (var i = 0; i < sizes.length; i++) {
        if (sizes[i] === label) {
          break;
        }
      }
      sizes.splice(i, 1);
    }
    setCurrentDragColorSizes(sizes);
  };
  const setupProduct = (item) => {
    console.log("ITEM", item);
    price = item[0].sizes[0].price;
    let sizes = new Array();

    let currItem = currentItem ? currentItem : item[0];

    for (var i = 0; i < currItem.sizes.length; i++) {
      if (loginStatus)
        sizes.push(<div><Button key={i} variant="secondary" disabled data={i} onClick={(event) => { sizeClick(event); }}>{currItem.sizes[i].sizeName}<br />${currItem.sizes[i].price.toLocaleString(undefined, { maximumFractionDigits: 2 })}</Button></div>);
      else
        sizes.push(<div><Button key={i} variant="secondary" data={i} onClick={(event) => { sizeClick(event); }}>{currItem.sizes[i].sizeName}</Button></div>);
    }

    setAvailableColors([...item]);
  }
  const addColorDrop = (e) => {
    console.log("COLOR DROPPED IN COLOR DIV");
    setCurrentDragColorSizes(new Array());
    console.log(currentDragColor);
    setAddSizes([...addSizes, currentDragColor]);
  };

  const handleAddSizesClick = () => {
    //dispatch(addColor(currentDragColorSizes));
  };

  const removeColorDrop = (e) => {
    console.log("COLOR DROPPED IN REMOVE COLOR DIV");
    console.log(currentDragColor);
  };

  const allowDrop = (e) => {
    e.preventDefault();
  };

  const dragStarted = (item) => {
    setCurrentDragColor(item);
  }

  const addToCatalog = async () => {
    setShowSpinner(true);
    console.log("SELETED DECORATION:", selectedDecoration);
    let item = await CatalogService.addCatalogItem({ items: selectedColors, decorationCode: selectedDecoration });
    setShowSpinner(false);
    navigate("/admin/allcatalog/1");
  }
  let price = 0;

  return (
    <>
    {!catalogItem && (<Spinner animation="border" />)}
    {catalogItem && (
    <div className="container">
      <div class="product-details-container">
        <div class="product-img-lg">
          <img src={imgSrcBack} width={50}></img>
          <img src={imgSrc} width={'500'}></img>
        </div>
        <div class="product-content">
          <div class="title">{catalogItem && catalogItem[0].title}</div>
          <div class="description" dangerouslySetInnerHTML={{ __html: catalogItem && catalogItem[0].htmlDescription ? catalogItem[0].htmlDescription : catalogItem[0].description }} />
          <div class="color-title">
            Color: {currentColor}
          </div>
          <div class="color-title">
            Selected Colors:
          </div>
          <div class="colors" onDrop={addColorDrop} onDragOver={allowDrop} >
            {selectedColors && selectedColors.map(item => (
              <div class="color-swatch">
                {item.hexColor && item.hexColor != "" && (
                  <div style={{ backgroundColor: item.hexColor, width: 50, height: 50 }}
                    onClick={(event) => colorImageClick(item)}
                    onMouseOver={(event) => colorImageOver(item)}
                    onMouseLeave={() => colorImageExit(item)}
                    onDragEnd={drop}
                    onDragStart={() => dragStarted(item)}
                    key={item.colorName}
                    draggable
                  ></div>
                )}
                {item.squareImageName && item.squareImageName != "" && (
                  <img src={`https://cdnm.sanmar.com/swatch/gifs/${item.squareImageName}`} height={50}
                    onClick={(event) => colorImageClick(item)}
                    onMouseOver={(event) => colorImageOver(item)}
                    onMouseLeave={() => colorImageExit(item)}
                    onDragEnd={drop}
                    onDragStart={() => dragStarted(item)}
                    key={item.colorName}
                    draggable
                  />

                )}
              </div>
            ))}

          </div>
          <div>
            <Button onClick={addAll}>Add All Colors</Button> &nbsp;
            <Button onClick={removeAll} variant="warning">Remove All Colors</Button>
          </div>
          <div class="color-title">
            Available Colors:
          </div>
          <div class="colors" onDrop={removeColorDrop} onDragOver={allowDrop}>
            {availableColors && availableColors.map(item => (
              <div class="color-swatch">
                {item.hexColor && item.hexColor != "" && (
                  <div style={{ backgroundColor: item.hexColor, width: 50, height: 50 }}
                    onClick={(event) => colorImageClick(item)}
                    onMouseOver={(event) => colorImageOver(item)}
                    onMouseLeave={() => colorImageExit(item)}
                    onDragEnd={() => drop(item)}
                    onDragStart={() => dragStarted(item)}
                    key={item.colorName}
                    draggable

                  ></div>
                )}
                {item.squareImageName && item.squareImageName != "" && (
                  <img src={`https://cdnm.sanmar.com/swatch/gifs/${item.squareImageName}`} height={50}
                    onClick={(event) => colorImageClick(item)}
                    onMouseOver={(event) => colorImageOver(item)}
                    onMouseLeave={() => colorImageExit(item)}
                    onDragEnd={() => drop(item)}
                    onDragStart={() => dragStarted(item)}
                    key={item.colorName}
                    draggable
                  />
                )}
              </div>
            ))}
          </div>
          <Button onClick={addToCatalog} disabled={showSpinner}>
            {showSpinner && <Spinner size="sm" animation="border" />} Add Product to Catalog
          </Button>
          <br />
          <br />
          <br />
        </div>
      </div>

      <Modal show={show} onHide={handleSizeModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Available Sizes for<br /> {currentDragColor}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {addSizes}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSizeModalClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddSizesClick}>
            Add Sizes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>)}
    </>
  );
};
export default ProductDetails;